import React from 'react'
import { Link } from 'react-router-dom';
import styles from './MoreBtn.module.scss'
import { cookieUtil } from '@/assets/js/cookie'

const handleClick = () => {
  cookieUtil.set('showNav', true)
}
export const MoreBtn = (props) => {
  return (
    <Link to={props.link} className={styles.MoreBtn} onClick={e=>{handleClick(e)}}>更多产品</Link>
  )
}
